export default __webpack_public_path__ + "static/media/BANANA-SFP-BNB.0232cdcb.svg";